import scrollParent from './scroll-parent';
import Wix from './wix-sdk-polyfill';
import { isInWix } from './is-in-wix';
import { isMobile, isEditor } from './wix-sdk-utils';

export const scrollToAppTop = () => {
  if (!isInWix() || isEditor()) {
    scrollTo(0);
    return;
  }

  Wix.getBoundingRectAndOffsets(({ offsets: { x, y }, rect: { top } }) => {
    Wix.getAdsOnPage(({ top: { height = 0 } = {} }) => {
      if (top >= height) {
        return;
      }
      Wix.scrollTo(x, isMobile() ? y : y - height);
    });
  });
};

export default function scrollTo(position) {
  const parent = scrollParent();
  if (typeof parent.scrollTo === 'function') {
    parent.scrollTo(0, position);
  } else {
    parent.scrollTop = position;
  }
}
